module.exports = __webpack_public_path__ + "908e4d2e/img/rename-icon.de4e673d.svg";